"use strict";const e=require("../helpers/createFields.js"),t=e.createFields({interestedInProfile:{__type:"checkbox",label:"field.profile_interest_v2",name:"interestedInProfile"}});module.exports=t;
